import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "titlebar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "titlebar-title --mobile" }, [
    /*#__PURE__*/_createElementVNode("span", {
      style: {"font-size":"16px","margin-left":"10px"},
      class: ""
    }, "Valores da Inspeção")
  ])
], -1)
const _hoisted_3 = { class: "titlebar-actions" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_5 = { class: "titlebar-actions-primary" }
const _hoisted_6 = { class: "ui-button-content" }
const _hoisted_7 = { class: "ui-button-content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "Salvar", -1)
const _hoisted_9 = { class: "ui-card" }
const _hoisted_10 = {
  key: 0,
  class: "ui-card-body"
}
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_combo_segurado = _resolveComponent("combo-segurado")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_combo_cidade = _resolveComponent("combo-cidade")!
  const _component_card = _resolveComponent("card")!
  const _component_inspecao_valores = _resolveComponent("inspecao-valores")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.storeApp.state.apresentarLogoExterna?'ui-page ui-acesso-externo':'ui-page')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.state.gerarPdf)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                class: "ui-button",
                loading: _ctx.state.gerandoPdf,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gerarPdf()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_icone, { nome: "pdf" }),
                    _createTextVNode(),
                    _createElementVNode("div", null, _toDisplayString(_ctx.state.gerandoPdf? 'Aguarde por favor... Estamos gerando o seu PDF': 'Visualizar PDF'), 1)
                  ])
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (!_ctx.state.gerandoPdf)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "ui-button -primary",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar()))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_icone, { nome: "salvar-personalizacoes" }),
                  _hoisted_8
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              (_ctx.state.apresentarCampos)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_a_spin, {
                      tip: "Aguarde por favor ... Estamos obtendo informações do CNPJ na Receita Federal.",
                      spinning: _ctx.state.consultandoCnpj
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card, { titulo: "SEGURADO" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_a_form_item, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(), _createBlock(_component_combo_segurado, {
                                      codigo: _ctx.state.inspecaovalores.codigoCadastro,
                                      "onUpdate:codigo": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.inspecaovalores.codigoCadastro) = $event)),
                                      key: 'SEGUR-' + _ctx.state.inspecaovalores.codigoCadastro,
                                      disabled: true
                                    }, null, 8, ["codigo"]))
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createVNode(_component_card, { titulo: "LOCAL DE RISCO" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_a_form_item, { label: "Local de Risco" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("input", {
                                          type: "text",
                                          class: "ant-input",
                                          value: _ctx.state.inspecao.identificacaoLocal,
                                          disabled: ""
                                        }, null, 8, _hoisted_15)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_16, [
                                    _createVNode(_component_a_form_item, { label: "Endereço" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("input", {
                                          type: "text",
                                          class: "ant-input",
                                          value: _ctx.obtemEnderecoLocalRisco(),
                                          disabled: ""
                                        }, null, 8, _hoisted_17)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_a_form_item, { label: "Cidade/UF" }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createBlock(_component_combo_cidade, {
                                          codigo: _ctx.state.inspecao.codigoCidade,
                                          "onUpdate:codigo": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.inspecao.codigoCidade) = $event)),
                                          key: 'CID-' + _ctx.state.inspecao.codigoCidade,
                                          disabled: true
                                        }, null, 8, ["codigo"]))
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_inspecao_valores, {
                          inspecaoValores: _ctx.state.inspecaovalores,
                          "onUpdate:inspecaoValores": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.inspecaovalores) = $event)),
                          "bloquear-campos": _ctx.state.bloquearCampos
                        }, null, 8, ["inspecaoValores", "bloquear-campos"])
                      ]),
                      _: 1
                    }, 8, ["spinning"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ], 2))
}